export const Fees = {
    LOADING_FEES_LIST: "LOADING_FEES_LIST",
    GET_FEES_LIST: "GET_FEES_LIST",
  };